var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntiguaAndBarbuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1225)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 0H49V40H-10V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 0H49L45.1522 20H-6.15217L-10 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.9997L6.67395 15.6519L13.2101 14.3797L7.65044 10.6601L14.1678 12.0284L10.4307 6.42883L15.937 10.2293L14.5915 3.60144L18.2491 9.25535L19.5 2.6084L20.751 9.25535L24.4086 3.60144L23.0631 10.2293L28.5694 6.42883L24.8323 12.0284L31.3496 10.6601L25.7899 14.3797L32.3261 15.6519L19.5 19.9997Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.15222 15.6523H45.1521V24.348H-6.15222V15.6523Z",
    fill: "#0072C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 0L19.5 40L49 0V40H-10V0Z",
    fill: "#CE1126"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 40,
    fill: "white",
    transform: "translate(-10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiguaAndBarbuda);
export default __webpack_public_path__ + "static/media/antigua_and_barbuda.c27c6b0584ac2d90e62e2e4f50694081.svg";
export { ForwardRef as ReactComponent };